var originalPrefix = '_orig_';
var I18NTranslated = /** @class */ (function () {
    function I18NTranslated() {
    }
    return I18NTranslated;
}());
export { I18NTranslated };
/**
 * Applies the translation to the i18n properties
 * @param target An array of {@link I18NTranslated} on which translations will be applied.
 */
export function applyTranslations(target) {
    return target.map(function (incoming) {
        if (!incoming.i18n)
            return incoming;
        var props = Object.keys(incoming.i18n)
            .filter(function (p) { return p !== 'lang'; });
        if (props.length === 0)
            return incoming;
        var translateable = Object.assign({}, incoming);
        var i18n = translateable.i18n;
        props.forEach(function (prop) {
            var _a;
            var translation = i18n[prop];
            var initial = translateable[prop];
            Object.assign(translateable, (_a = {},
                _a[originalPrefix + prop] = initial,
                _a[prop] = translation || initial,
                _a));
        });
        return translateable;
    });
}
